export const AVAILABLE_FILE_EXTENSIONS = [
  'apng', 'blp', 'bufr', 'cur', 'pcx', 'dcx', 'dds', 'ps', 'eps', 'fit', 'fits', 'fli', 'flc', 
  'ftc', 'ftu', 'gbr', 'grib', 'h5', 'hdf', 'heic', 'heif', 'jp2', 'j2k', 'jpc', 'jpf', 'jpx',
  'j2c', 'icns', 'ico', 'im', 'iim', 'mpg', 'mpeg', 'tif', 'tiff', 'mpo', 'msp', 'palm', 'pcd', 
  'pdf', 'pxr', 'psd', 'qoi', 'bw', 'rgb', 'rgba', 'sgi', 'ras', 'tga', 'icb', 'vda', 'vst', 'webp',
  'wmf', 'emf', 'xbm', 'xpm', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'raw', 'dng',
]

export const AVAILABLE_FILE_MIME_TYPES = [
  'image/apng',
  'image/x-blp',
  'application/octet-stream', // .bufr
  'image/x-icon', // .cur
  'image/x-pcx', // .pcx
  'image/x-dcx',
  'image/vnd.ms-dds',
  'application/postscript', // .ps, .eps
  'image/fits', // .fit, .fits
  'video/x-fli', // .fli, .flc
  'image/x-ftc', // .ftc
  'image/x-ftu', // .ftu
  'image/x-gimp-gbr',
  'application/octet-stream', // .grib
  'application/x-hdf', // .h5, .hdf
  'image/heic',
  'image/heif',
  'image/jp2', // .jp2, .j2k, .jpc, .jpf, .jpx, .j2c
  'image/icns',
  'image/vnd.microsoft.icon',
  'image/im', // rarely used
  'image/x-iim', // .iim
  'video/mpeg', // .mpg, .mpeg
  'image/tiff', // .tif, .tiff
  'image/mpo',
  'image/x-mspaint',
  'image/x-palm',
  'image/x-photo-cd',
  'application/pdf',
  'image/x-pxr',
  'image/vnd.adobe.photoshop',
  'image/qoi',
  'image/x-rgb', // .bw, .rgb, .rgba
  'image/sgi',
  'image/x-cmu-raster',
  'image/x-tga', // .tga, .icb, .vda, .vst
  'image/webp',
  'image/wmf',
  'image/emf',
  'image/x-xbitmap',
  'image/x-xpixmap',
  'image/jpeg', // .jpg, .jpeg
  'image/png',
  'image/gif',
  'image/bmp',
  'image/svg+xml', // .svg
  'image/x-raw', // .raw
  'image/x-dng', // .dng
  'image/x-raw-dng', // .dng
]
